import { render } from "./GrantsList.vue?vue&type=template&id=18d28ee3"
import script from "./GrantsList.vue?vue&type=script&lang=js"
export * from "./GrantsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/GrantsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18d28ee3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18d28ee3', __exports__)) {
    api.reload('18d28ee3', __exports__)
  }
  
  module.hot.accept("./GrantsList.vue?vue&type=template&id=18d28ee3", () => {
    api.rerender('18d28ee3', render)
  })

}


export default __exports__